import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

import isPropValid from '@emotion/is-prop-valid';
import { ExternalLink, SaveStates } from '@infl-ts/ui-advocate-components';
import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Box, Card, styled, Typography } from '@mui/material';
import * as E from 'fp-ts/Either';
import { useTranslation } from 'react-i18next';
import StageLayout from '../stage-layout';
import TwitterButton from '../twitter-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ResizableCard = styled(Card, {
  shouldForwardProp: isPropValid
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  height: 80px;\n  min-width: 192px;\n  width: ", ";\n  border: 1px solid rgb(0 0 0 / 10%);\n  padding: ", ";\n"])), function (p) {
  return p.isMobile ? '100%' : p.isTablet ? '192px' : '300px';
}, function (p) {
  return p.theme.spacing(1, 0);
});
var Content = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  padding: ", ";\n  padding-top: ", ";\n  color: ", ";\n  width: 100%;\n"])), function (p) {
  return p.theme.spacing(2);
}, function (p) {
  return p.theme.spacing(1);
}, function (p) {
  return p.theme.palette.text.primary;
});
var ProfileImage = styled('img')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  object-fit: contain;\n"])));

var TwitterFollow = function TwitterFollow(_ref) {
  var _twitterAccount$authU;

  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      twitterAccount = _ref.twitterAccount,
      isPreview = _ref.isPreview,
      prospect = _ref.prospect;
  var _stage$requiredFollow = stage.requiredFollowUser,
      handle = _stage$requiredFollow.handle,
      name = _stage$requiredFollow.name,
      followersCount = _stage$requiredFollow.followersCount,
      profileImageUrl = _stage$requiredFollow.profileImageUrl;
  var isMobile = useContainerMediaQuery({
    maxWidth: 'sm'
  });
  var isTablet = useContainerMediaQuery({
    maxWidth: 'md'
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(_Fragment, {
      children: twitterAccount && /*#__PURE__*/_jsx(TwitterButton, {
        connected: twitterAccount.connected,
        authUrl: (_twitterAccount$authU = twitterAccount === null || twitterAccount === void 0 ? void 0 : twitterAccount.authUrl) !== null && _twitterAccount$authU !== void 0 ? _twitterAccount$authU : '',
        status: mutationValue,
        defaultText: stage.completionText || t('Follow on Twitter'),
        savingText: t('Following...'),
        completedText: t('Followed'),
        onClick: function onClick() {
          completeStage({
            twitterFollowInput: {
              stageID: stage.id,
              activityID: activity === null || activity === void 0 ? void 0 : activity.id
            }
          });
        },
        isPreview: isPreview
      })
    }),
    "data-element": "StageLayout",
    "data-component": "TwitterFollow",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(ExternalLink, {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://twitter.com/".concat(handle),
      "data-element": "ExternalLink",
      "data-component": "TwitterFollow",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsx(ResizableCard, {
        isMobile: isMobile,
        isTablet: isTablet,
        "data-element": "ResizableCard",
        "data-component": "TwitterFollow",
        "data-source-file": "index.tsx",
        children: /*#__PURE__*/_jsxs(Content, {
          "data-element": "Content",
          "data-component": "TwitterFollow",
          "data-source-file": "index.tsx",
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              mt: 1,
              mr: 2
            },
            "data-element": "Box",
            "data-component": "TwitterFollow",
            "data-source-file": "index.tsx",
            children: /*#__PURE__*/_jsx(ProfileImage, {
              src: profileImageUrl,
              height: 40,
              width: 40,
              alt: "Twitter profile image",
              "data-element": "ProfileImage",
              "data-component": "TwitterFollow",
              "data-source-file": "index.tsx"
            })
          }), /*#__PURE__*/_jsxs(Box, {
            "data-element": "Box",
            "data-source-file": "index.tsx",
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h5",
              "data-element": "Typography",
              "data-source-file": "index.tsx",
              children: name
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "body2",
              sx: {
                mt: 1
              },
              "data-element": "Typography",
              "data-source-file": "index.tsx",
              children: t('{{followersCount}} followers', {
                followersCount: followersCount
              })
            })]
          })]
        })
      })
    })
  });
};

export default TwitterFollow;